export default __webpack_public_path__ + "static/media/Mockup-01.5ee235bf.gif";